import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import UserYesterdayActivity from './UserYesterdayActivity'
import {
  getIdentityCanCompletePreviousActivityInWorkday,
  getIdentityCanCompletePreviousActivity,
  getIdentityActiveProTrackName,
  getIdentityLastUserActivity,
  getIdentityIsWorkingDay,
  isCommittedNotificationTimeHasCome,
} from 'store/entities/identity/selectors'
import { getUIWindowSizesWidth } from 'store/entities/ui/selectors'
import { sendYesterdayActivity } from 'store/entities/identity/actions'

const mapStateToProps = createStructuredSelector({
  isMobile: getUIWindowSizesWidth,
  canCompletePreviousInWorkday: getIdentityCanCompletePreviousActivityInWorkday,
  canCompletePrevious: getIdentityCanCompletePreviousActivity,
  proTrackName: getIdentityActiveProTrackName,
  yesterdayActivity: getIdentityLastUserActivity,
  isWorkday: getIdentityIsWorkingDay,
  commitedTimeHasCome: isCommittedNotificationTimeHasCome,
})

const mapDispatchToProps = {
  sendYesterdayActivity,
}

const mergeProps = (
  {
    yesterdayActivity,
    canCompletePreviousInWorkday,
    canCompletePrevious,
    isWorkday,
    commitedTimeHasCome,
    ...restState
  },
  { sendYesterdayActivity, ...restDispatch },
  ownProps
) => ({
  sendYesterdayActivity: actionType =>
    sendYesterdayActivity({
      activityId: yesterdayActivity.get('id'),
      userActivityId: yesterdayActivity.get('userActivityId'),
      actionType,
    }),
  yesterdayActivity,
  show: isWorkday ? canCompletePreviousInWorkday && !commitedTimeHasCome : canCompletePrevious,
  ...restState,
  ...restDispatch,
  ...ownProps,
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UserYesterdayActivity)
